import { useEffect, useRef, useState } from 'react'
import { Button, message, Upload, Form, Modal } from 'antd'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBoxVertical/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, momentFormat } from '@/utils/utils'
import { useDictModel } from '../../../../base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { YHDetailNav } from '@/components/YHDetailNav'
import { IMapInfo, YHChooseMap } from '@/components/YHChooseMap'
import { useJoinIntention } from '../../intentionModel'
import FontIcon from '@/components/YhIcon'
import { UploadOutlined } from '@ant-design/icons'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseRequestUrl, getBaseUploadData, getToken } from '@/utils/constants'
import { RcFile, UploadChangeParam } from 'antd/lib/upload'
import { intentionService } from '../../intentionService'
import moment from 'moment'
import { ISelectOptions } from '@/types/AppTypes'
import axios from 'axios'
export const JoinIntentionDetails = () => {
    const { getSelectedDictOne, getTreeNodeOne } = useDictModel()
    const { addFormVal, editFormVal, updateAddFormVal, updateEditFormVal, insertData, editData, getOne, defaultMapData, setDefaultMapData } = useJoinIntention()
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const formValInfo = detailsInfo.mode === 'add' ? addFormVal : editFormVal
    const formRef = useRef<IYhFormRef>()
    const reader = useRef<any>(new FileReader())
    useEffect(() => {}, [detailsInfo])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav('2-1-1') && updateAddFormVal(null)
        }
    }, [selectedNavId])

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === 'edit') {
            getOne(detailsInfo.id)
        }
    }, [detailsInfo])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, '2-1')
    }
    //表单提交
    const onSubmit = async () => {
        formRef.current
            ?.validateFields()
            .then((val) => {
                const { fileList = [], followUpMethod, createTime, intentionLevel, followUpContent, feedback, createUser, ...value } = val
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    value.md5 = file?.uid
                    value.fileName = file?.name
                } else {
                    value.md5 = ''
                    value.fileName = ''
                }
                value.fileList = null
                let data = {
                    ...(detailsInfo.mode === 'add' ? addFormVal : editFormVal),
                    ...value,
                    createTime: null,
                }
                delete data.fileList
                if (followUpMethod) {
                    data.followUp =
                        detailsInfo.mode === 'add'
                            ? {
                                  followUpMethod,
                                  createTime: createTime ? moment(createTime).format('YYYY-MM-DD HH:mm:ss') : null,
                                  intentionLevel,
                                  followUpContent,
                                  feedback,
                                  createUser,
                              }
                            : {}
                }
                if (detailsInfo.mode === 'edit') {
                    editData({ ...data, id: detailsInfo.id }).then((res) => {
                        res && onClose()
                        updateEditFormVal(null)
                    })
                } else {
                    insertData(data).then((res: any) => {
                        res && onClose()
                        updateAddFormVal(null)
                    })
                }
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }
    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        isFormItem && formRef.current?.setFieldsValue(val)
        detailsInfo.mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues, false)
    }

    //地图选择
    const [chooseMapVisible, setChooseMapVisible] = useState<boolean>(false)
    const saveAddress = (data) => {
        const { addr, longitude, latitude, info } = data
        const { province, city, district } = info.address_component
        saveCache({ longitude: longitude, latitude: latitude, address: addr, province, city, district })
        setChooseMapVisible(false)
    }

    const onCloseMap = () => {
        setChooseMapVisible(false)
    }
    const handleChooseRepairAddress = () => {
        const { address, longitude, latitude } = formValInfo
        setDefaultMapData({
            name: address,
            addr: address,
            longitude: longitude,
            latitude: latitude,
        })
        setChooseMapVisible(true)
    }

    const normFile = (e: UploadChangeParam) => {
        let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
        let isType: boolean = false
        let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf('.'))
        isType = filetypes?.includes(fileEnd) ?? false
        console.log('Upload event:', e)
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 200) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                }
                e.fileList = [data]
                // e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        if (!isType) {
            e.fileList?.pop()
        }
        return e && e.fileList
    }

    const franchiseEquipmentSelectChange = (value: string) => {
        const node = getTreeNodeOne(value as DictCodeEnmu)
        if (node && node.length > 0) {
            const value = node[0].value
            formRef.current?.setFieldsValue({ mainConfig: value })
        }
    }

    const getLicense = async(info) => {
        const imageUrl = getBaseImgLookUrl(info.response.retData)
        let blobData = await axios({
            method: 'get',
            url: imageUrl,
            responseType: 'blob', // 重要: 设置响应类型为blob
        })
        const blob = blobData.data
        // 如果需要，可以创建一个File对象（这里假设文件名是'image.jpg'）
        const file = new File([blob], 'image.png', { type: blob.type })
        // 创建一个FormData对象
        const formData = new FormData()
        // 将File或Blob对象添加到FormData对象中
        formData.append('file', file || blob) // 如果不需要File对象，可以直接使用blob
        let {retData} = await intentionService.vehicleLicense(formData)
        if(retData && retData.error_code){
            return message.error(`图像识别错误：${retData.error_msg}`)
        }
        const { "单位名称":{words: invoiceTitle}, "社会信用代码":{words: licenseNo}, "地址":{words:  postAddress}, "法人":{words: corporation}} = retData.words_result
        saveCache({invoiceTitle, licenseNo, postAddress, corporation})
    }

    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '加盟商编号',
                fieldName: 'code',
                span: 4,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '加盟商名称',
                fieldName: 'name',
                span: 4,
                rules: [{ required: true, message: '请输入加盟商名称' }],
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '负责人',
                fieldName: 'contact',
                span: 4,
                rules: [{ required: true, message: '请输入负责人' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系电话',
                fieldName: 'phone',
                span: 4,
                rules: [{ required: true, message: '请输入联系电话' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '地址',
                fieldName: 'address',
                placeholder: '请选择地址',
                rules: [{ required: true, message: '请选择地址' }],
                span: 4,
                disable: true,
                addonAfter: (
                    <span style={{ cursor: 'pointer', fontSize: '14px', color: '#666' }} onClick={handleChooseRepairAddress}>
                        选择地址
                    </span>
                ),
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '加盟类型',
                fieldName: 'franchiseType',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISEE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '业务经理',
                fieldName: 'businessManager',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '经营性质',
                fieldName: 'businessNature',
                options: getSelectedDictOne(DictCodeEnmu.BUSINESS_NATURE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '资质',
                fieldName: 'qualification',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISE_QUALIFICATION),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '加盟设备',
                fieldName: 'franchiseEquipment',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISE_EQUIPMENT),
                span: 4,
                onSelectChange: franchiseEquipmentSelectChange,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '公司规模',
                fieldName: 'companySize',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '人员储备',
                fieldName: 'personnelReserves',
                options: getSelectedDictOne(DictCodeEnmu.PERSONNEL_RESERVES),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '主要配置',
                placeholder: '自动生成',
                fieldName: 'mainConfig',
                span: 24,
            },
        ],
    }

    const invoiceFormItem: IYhFormItemsBox = {
        title: '开票信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '发票抬头',
                fieldName: 'invoiceTitle',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '纳税人识别号',
                fieldName: 'licenseNo',
                span: 4,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '企业地址',
                fieldName: 'postAddress',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '公司法人',
                fieldName: 'corporation',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '开户银行',
                fieldName: 'bank',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '银行账户',
                fieldName: 'bankAcct',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '上传营业执照',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item name="fileList" label="上传营业执照" valuePropName="fileList" getValueFromEvent={normFile}>
                        <Upload
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            // disabled={editModel === 'look'}
                            beforeUpload={(file) => {
                                let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
                                // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
                                // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                let isType = filetypes?.includes(fileEnd)
                                if (!isType) {
                                    message.error('不支持该格式的上传,当前仅支持 图片、pdf和.doc 类型文件')
                                }
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                }
                                return isType && isLt20M
                            }}
                            iconRender={(file) => {
                                if (file?.type?.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                                if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                                if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                            }}
                            onPreview={(node) => {
                                Modal.info({
                                    title: '图片查看',
                                    // eslint-disable-next-line react/jsx-no-undef
                                    content: <img style={{ width: '100%' }} src={getBaseImgLookUrl(node?.uid as string)} />,
                                    okText: '确定',
                                    cancelText: '取消',
                                    centered: true,
                                    width: 800,
                                })
                            }}
                            onChange={(info) => {
                                if (info.file.status === 'done') {
                                    getLicense(info.file)
                                }
                            }}
                        >
                            <Button icon={<UploadOutlined />}>选择文件上传</Button>
                            <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>
                                提醒：上传单个文件不能超过20M,当前仅支持.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc类型文件
                            </span>
                        </Upload>
                    </Form.Item>
                ),
            },
        ],
    }

    const customerFormItem: IYhFormItemsBox = {
        title: '客户跟进',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '跟进方式',
                fieldName: 'followUpMethod',
                options: getSelectedDictOne(DictCodeEnmu.FOLLOW_UP),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '跟进时间',
                fieldName: 'createTime',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '意向程度',
                fieldName: 'intentionLevel',
                options: getSelectedDictOne(DictCodeEnmu.INTENTION_LEVEL),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '跟进内容',
                fieldName: 'followUpContent',
                span: 4,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '反馈意见',
                fieldName: 'feedback',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '跟进人员',
                fieldName: 'createUser',
                span: 4,
            },
        ],
    }

    const fromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: detailsInfo.mode === 'edit' ? editFormVal : addFormVal,
        onChange,
        boxs: detailsInfo.mode === 'add' ? [baseFormItem, invoiceFormItem, customerFormItem] : [baseFormItem, invoiceFormItem],
    }

    const action = (
        <>
            <Button className="mr-10" shape="round" onClick={() => onSubmit()} type="primary" style={{ float: 'right' }}>
                保存
            </Button>
            <Button className="mr-10" shape="round" onClick={onClose} style={{ float: 'right' }}>
                返回
            </Button>
        </>
    )

    return (
        <>
            <YHDetailNav
                title={detailsInfo.mode === 'edit' ? <span>意向加盟编辑</span> : <span>意向加盟新增</span>}
                btns={action}
                style={{ marginBottom: '8px' }}
            />
            <YhFormBox {...fromConfig} />
            {chooseMapVisible && (
                <YHChooseMap
                    visible={chooseMapVisible}
                    setVisible={setChooseMapVisible}
                    defaultMapData={defaultMapData}
                    saveAddress={saveAddress}
                    onCloseMap={onCloseMap}
                />
            )}
        </>
    )
}
